<template>
    <div class="usps-container">
        <article
            class="usps "
            :class="showBackground"
            :style="{...generateStylingVariables(content.style)}"
        >
            <div
                class="usps__inner"
                :class="makeContainer"
            >
                <zoe-atom-text
                    v-if="stringIsNotEmpty(content.header.value)"
                    :item="content.header.value"
                    class="usps__header"
                />

                <ul
                    class="usps__list"
                    :class="ignoreTextHeight(content.ignoreTextHeight.value)"
                    :data-columns-desktop="content.columnCount.value"
                >
                    <li
                        v-for="(item, index) in filteredItems"
                        :key="index"
                        class="usps__item"
                        :class="showBorder"
                    >
                        <div
                            v-if="stringIsNotEmpty(item.text.value)"
                            class="usps__item-inner"
                            :class="alignToTop(item.alignToTop?.value)"
                        >
                            <zoe-atom-media
                                :item="item.media?.value || item.icon?.value || item.image?.value"
                                class="usps__media"
                                :lazy-loading-on-mobile="true"
                            />

                            <div class="usps__content">
                                <zoe-atom-text
                                    :item="item.text.value"
                                    class="usps__text"
                                />
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </article>
    </div>
</template>

<script>
import ZoeAtomMedia from '../../../../atoms/media/v1.0.0/zoe-atom-media.vue';
import ZoeAtomText from '../../../../atoms/text/v1.0.0/zoe-atom-text.vue';
import Page from '../../../../../../../resources/frontend/js/mixins/page.vue';
import Component from '../../../../../mixins/component/component.vue';
import { generateStylingVariables } from '@mixins/styling/styling';
import {getTextWithConditions} from '@mixins/utils/conditions';
import {stringIsNotEmpty} from '../../../../../../../resources/frontend/js/mixins/get-page-data';

export default {
    components: {
        ZoeAtomMedia,
        ZoeAtomText,
    },

    mixins: [Page, Component],

    computed: {
        showBackground() {
            return this.content.style.background.turnOff.value ? '' : 'usps--background';
        },

        showBorder() {
            return  this.content.style.border.turnOff.value ? '' : 'usps__item--border';
        },

        makeContainer() {
            return !this.content.style.background.turnOff.value ? 'container' : '';
        },

        filteredItems() {
            return this.content.items.filter(item => {
                return stringIsNotEmpty(getTextWithConditions(item.text.value));
            });
        },
    },

    methods: {
        generateStylingVariables,
        ignoreTextHeight(option) {
            return option ? 'usps__list--column' : 'usps__list--grid';
        },

        alignToTop(option) {
            return option ? 'usps__item-inner--align-start' : '';
        },
    },
};
</script>

<style lang="scss" scoped>
.usps {
    --background: v-bind('content.style.background.color.value');
    --border: v-bind('content.style.border.color.value');
}

@import "zoe-organism-usps";
</style>
